<template>
  <div>
    <!-- ヘッダ -->
    <comVFHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyName"></comVFHeaderAuth>
    <v-main>
      <v-container fluid>
        <!-- 検索条件 -->
        <div class="group-box">
          <span class="box-title">検索条件</span>
            <v-row dense>
              <v-col cols="1" class="d-flex align-center justify-center search-title ">
                <label class="tbl-lbl-blcok">受付日</label>
              </v-col>

              <v-col cols="2" class="mr-0 search-date">
                <v-menu
                  v-model="menuSrtReceiptDateFlg"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  >
                    <template v-slot:activator="{ on, attrs }" >
                      <v-text-field
                        v-model="srtReceiptDate"
                        label="開始日"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        clearable
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="srtReceiptDate"
                      @input="menuSrtReceiptDateFlg = false"
                    ></v-date-picker>
                  </v-menu>
              </v-col>
              
              <v-col cols="1" class="d-flex align-center justify-center" style="max-width: 20px">
                <span >～</span>
              </v-col>

              <v-col cols="2" class="search-date">
                <v-menu
                  v-model="menuEndReceiptDateFlg"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="endReceiptDate"
                      label="終了日"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endReceiptDate"
                      @input="menuEndReceiptDateFlg = false"
                    ></v-date-picker>
                  </v-menu>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-center">
              受付番号
              </v-col>

              <v-col cols="2">
                <v-text-field
                  v-model="srchReceiptNo"
                  label=""
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="d-flex align-center justify-center" >
                確認状態
              </v-col>

              <v-col cols="2">
                <v-select
                  v-model="selectStatus"
                  :items="status"
                  item-text="name"
                  item-value="cd"
                  multiple
                  label="複数選択できます"
                  clearable
                ></v-select>
              </v-col>
            </v-row>

          <v-row dense>
            <v-col cols="1" class="d-flex align-center justify-center search-title ">
              <label class="tbl-lbl-blcok">申請日</label>
            </v-col>

            <v-col cols="2" class="mr-0 search-date">
              <v-menu
                v-model="menuSrtAppDateFlg"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                >
                  <template v-slot:activator="{ on, attrs }" >
                    <v-text-field
                      v-model="srtAppDate"
                      label="開始日"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      readonly
                      clearable
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="srtAppDate"
                    @input="menuSrtAppDateFlg = false"
                  ></v-date-picker>
                </v-menu>
            </v-col>
              
            <v-col cols="1" class="d-flex align-center justify-center" style="max-width: 20px">
              <span >～</span>
            </v-col>

            <v-col cols="2" class="search-date">
              <v-menu
                v-model="menuEndAppDateFlg"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endAppDate"
                    label="終了日"
                    persistent-hint
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endAppDate"
                    @input="menuEndAppDateFlg = false"
                  ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-center">
              申請者名
            </v-col>

            <v-col cols="3">
              <v-text-field
                v-model="srchUserName"
                label="フリガナまたは漢字の前方一致"
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="2" class="d-flex align-start justify-center">
              <v-btn
                x-large
                color="success"
                dark
                min-width="120px"
                @click="search()"
                >{{ $t("LCM001") }}</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <!-- 検索結果一覧 -->
        <v-data-table 
          :headers="headers" 
          :items="desserts"
          item-key="no"
          :items-per-page="10"
          :loading="datatableLoading" 
          loading-text="Loading... Please wait"
          class="v-dtbl-md-1 v-dtbl-head-md-1 elevation-1"
          :no-data-text="$t('webmsg.common.datatblenodata')"
          >
          <template v-slot:[`item.displayValidityperiodEndDatetime`]="{ item }">
            <template v-if="item.expired">
              <span class="red--text"> {{ item.displayValidityperiodEndDatetime }}</span>
            </template>
            <template v-else>
              {{ item.displayValidityperiodEndDatetime }}
            </template>
          </template>
          <template v-slot:[`item.verifyStatusKbn`]="{ item }">
            <v-chip :color="item.verifyStatusKbn.color" text-color="white" >
              <v-icon left>{{ item.verifyStatusKbn.icon }}</v-icon>
                {{ item.verifyStatusKbn.name }}
            </v-chip>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <template v-if="item.applied">
              <v-btn small color="success" dark min-width="80px" elevation="5" @click="dispConfirmView(item.receiptNo)">{{ $t("LCM005") }}</v-btn>
            </template>
          </template>
        </v-data-table>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
  </div>
</template>

<script>
import Constants from "../common/constantsVf";
import Utils from "../common/utils";
export default {
  name: "VFReceiptAppListSearch",
  data() {
    return {
      screenTitle: "受付・申請一覧検索",
      screenId: "VFV200",
      userName: "",
      companyName: "",
      datatableLoading: false,
      headers: [
          { text: '受付番号', align: 'end', sortable: true, value: 'receiptNo', width: "10%" },
          { text: '受付日時', align: 'center', sortable: true, value: 'receiptDate', width: "12%" },
          { text: '申請日時', align: 'center', sortable: true, value: 'appDate', width: "12%" },
          { text: '期日', align: 'center', sortable: true, value: 'displayValidityperiodEndDatetime', width: "12%"},
          { text: '申請者名', align: 'start', sortable: true, value: 'appName'},
          { text: '確認状態', align: 'center', sortable: true, value: 'verifyStatusKbn', width: "10%" },
          { text: '詳細', align: 'center', sortable: false, value: 'edit', width: "10%" },

      ],
      desserts: [],
      srchReceiptNo: "",
      status: [],
      selectStatus: [],
      menuSrtReceiptDateFlg: "",
      srtReceiptDate: new Date().toISOString().substr(0, 10),
      menuEndReceiptDateFlg: "",
      endReceiptDate: new Date().toISOString().substr(0, 10),
      menuSrtAppDateFlg: "",
      srtAppDate: "",
      menuEndAppDateFlg: "",
      endAppDate: "",
      srchUserName: "",
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    // 画面用データストア破棄
    if (to.name != 'VFV210') {
      this.$store.commit("vfReceiptAppListSearch/resetState");
    }
    next();
  },
  methods: {
    /*
     * 初期表示
     */
    initialize() {
      this.setAuthUserInfo();
      this.getPullDown();

      // 再検索
      this.reSearch();
    },
    /**
     * 「検索」ボタン押下
     */
    search: async function () {    
      this.datatableLoading = true; 
      this.desserts = [];
      // 受付・申請情報一覧検索サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      let apiurl = Constants.URL_API_VFV200P01;
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
      try {
        // 入力データ
        let searchCondition = this.createCeachCond();
        let data = JSON.stringify(searchCondition);
        // API呼出
        let response = await this.$axios.post(apiurl,data,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        console.log(response);
        responseData = response.data
        // 受付・申請情報一覧表示
        this.displyReceiptAppList(responseData);
        this.dispVerifyStatusKbnInfo();
         // 画面用データストア(検索条件)登録
        this.$store.dispatch("vfReceiptAppListSearch/setSearchCondition", searchCondition);
      } catch(error) {
          console.log(error);
          apiErrorInfo = error;
      } finally {
        this.datatableLoading = false;
      }
      // 完了メッセージ表示
      this.showDialogMsgAfterAPICall(this.dlgMsg, apiErrorInfo, responseData);
    },
     /**
     * プルダウン情報取得
     */
    getPullDown: function() {
      let statusList = this.$store.getters["vfMaster/getVerifyStatusKbnList"];
      for (const value of statusList) {
        this.status.push({cd: value.value1, name: value.name});
      }
    },
     /**
     * 再検索処理
     */
    reSearch: function() {
      // 画面用データストア(検索条件)取得
      let searchCondition = this.$store.getters["vfReceiptAppListSearch/getSearchCondition"];
      if (searchCondition == null || !Object.keys(searchCondition).length || typeof searchCondition['receiptDateStart'] === "undefined") {
        return;
      }
      // 検索条件復元
      this.srtReceiptDate = searchCondition['receiptDateStart'];
      this.endReceiptDate = searchCondition['receiptDateEnd'];
      this.srchReceiptNo = searchCondition['receiptNo'];
      this.selectStatus = searchCondition['verifyStatusList'];
      this.srtAppDate = searchCondition['appDateStart'];
      this.endAppDate = searchCondition['appDateEnd'];
      this.srchUserName = searchCondition['appName'];
      // 再検索
      this.search();
    },

    /*
    * 検索用データ生成
    */
    createCeachCond : function() {
      let condData = {};
      condData['receiptNo'] = this.srchReceiptNo;
      condData['receiptDateStart'] = this.srtReceiptDate;
      condData['receiptDateEnd'] = this.endReceiptDate;
      condData['appDateStart'] = this.srtAppDate;
      condData['appDateEnd'] = this.endAppDate;
      condData['appName'] = this.srchUserName;
      condData['verifyStatusList'] = this.selectStatus;

      return condData;
    },
    /*
    * 受付・申請一覧表示
    */
    displyReceiptAppList : function(responseData) {
      this.desserts = new Array();
      if (responseData.data == null) {
        return;
      }
      let searchResultList = responseData.data.verifyReceiptAppListSearchResultDtoList;
      if (Utils.isEmptyArry(searchResultList)) {
        return;
      } 
      let receiptApp;
        for (const value of searchResultList) {
          receiptApp = {};
          receiptApp['receiptNo'] = value.receiptNo;
          receiptApp['receiptDate'] = value.receiptDatetime;
          receiptApp['appDate'] = value.appDatetime;
          receiptApp['displayValidityperiodEndDatetime'] = value.displayValidityperiodEndDatetime;
          receiptApp['appName'] = value.appName;
          receiptApp['verifyStatusKbn'] = {cd: value.verifyStatusKbn, name: value.verifyStatusKbnName};
          receiptApp['expired'] = value.expired;
          receiptApp['applied'] = value.applied;
          this.desserts.push(receiptApp);
        }
    },
    dispVerifyStatusKbnInfo : function() {
      this.verifyStatusKbnMstList = this.$store.getters["vfMaster/getVerifyStatusKbnList"];
      if (this.desserts == null || this.verifyStatusKbnMstList == null) {
          return;
      }
      this.desserts.forEach((dessert, index, arr) => {
        if (dessert.verifyStatusKbn.cd != null && dessert.verifyStatusKbn.cd != '') {
          let verifyStatus = this.getVerifyStatusNm(dessert.verifyStatusKbn.cd);
          if (verifyStatus != null) {
            arr[index].verifyStatusKbn.name = verifyStatus.nameAbbr;
            arr[index].verifyStatusKbn.color = verifyStatus.value2;
            arr[index].verifyStatusKbn.icon = verifyStatus.value3;
          }
        }
      });
    },
    getVerifyStatusNm(verifyStatusCd) {
      let retVal = "";
      let searchArry = "";
      if (verifyStatusCd != "") {
        searchArry = this.verifyStatusKbnMstList.find((v) => v.value1 === verifyStatusCd);
      }
      if (searchArry != null) {
        retVal = searchArry;
      }
      return retVal;
    },
    /*
    * 完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(dialog, apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm100', ['受付・申請一覧']);
        dialog.isOpen = true;
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
          return hasError;
        }else{
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
         return hasError;
        }
      }
    },
    /**
    * 詳細画面遷移
    */
    dispConfirmView(selectedReceiptNo) {
        this.$router.push(this.$router.resolve({ name: "VFV210", params: {receiptNo: selectedReceiptNo, srcScreenId: this.screenId} }).href);
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setVerifyLoginInfoVfMixin();
      this.username = authInfo['username'];
      this.companyName = authInfo['companyname'];
    },
  },
}
</script>
<style scoped>
.group-box {
  position: relative;
  margin: 1.3em 0;  padding: 0.3em 2em;
  border: solid 2px #141414;
  border-radius: 8px;
}
.group-box .box-title {
  position: absolute;
  display: inline-block;
  top: -13px;
  left: 10px;
  padding: 0 9px;
  line-height: 1;
  font-size: 18px;
  background: #fff;
  color: #0b0c0c;
  font-weight: bold;
}
.group-box p {
  margin: 0;
  padding: 0;
}
</style>